import { useState } from 'react'
import { Button, Card, Icon, Pill, Stack, Text } from '@/design-system'
import { BentoGrid, BentoSpan } from '@/components/Bento'
import { PageHeader } from '@/app/layouts/PageHeader'
import checkout from '@/app/layouts/CheckoutLayout.module.css'

const TOPICS = [
  { icon: 'send', title: 'A transfer has not arrived', body: 'Track it, or get it cancelled and refunded.' },
  { icon: 'credit_card', title: 'My card was declined', body: 'Limits, freezes and the three common causes.' },
  { icon: 'account_balance', title: 'Opening an account', body: 'What the $50 is for and when it lands.' },
  { icon: 'lock', title: 'I lost my phone', body: 'Freeze everything from another device, right now.' },
]

const THREADS = [
  { subject: 'Transfer to María Fernanda', status: 'Resolved', when: '18 Sep', agent: 'Ana · Spanish' },
  { subject: 'Card delivery to Queens', status: 'Open', when: '20 Sep', agent: 'Diego · Spanish' },
]

export function SupportScreen() {
  const [message, setMessage] = useState('')

  return (
    <>
      <PageHeader
        title="Support"
        subtitle="People, not a bot. Spanish and English, every day of the year."
        actions={<Pill tone="positive">Average reply: 4 minutes</Pill>}
      />

      <BentoGrid>
        <BentoSpan span={2}>
          <Card tone="light">
            <Text variant="caption" weight="semibold">What do you need help with?</Text>
            <div className={`${checkout.reasons} pb-mt-2`}>
              {TOPICS.map((topic) => (
                <button key={topic.title} type="button" className={checkout.reason} style={{ width: '100%', textAlign: 'left' }}>
                  <Icon name={topic.icon} size={20} />
                  <Stack grow gap={1}>
                    <Text variant="caption" weight="semibold">{topic.title}</Text>
                    <Text variant="eyebrow" tone="secondary">{topic.body}</Text>
                  </Stack>
                  <Icon name="chevron_right" size={18} />
                </button>
              ))}
            </div>
          </Card>
        </BentoSpan>

        <BentoSpan span={2}>
          <Stack gap={3}>
            <Card tone="dark">
              <Text variant="caption" weight="semibold" tone="onDark">Start a conversation</Text>
              <Text variant="caption" tone="onDarkMuted" className="pb-mt-2">
                Tell us what happened. Include the amount and the date if it is about a transfer.
              </Text>
              <textarea
                value={message}
                onChange={(event) => setMessage(event.target.value)}
                placeholder="I sent $500 to Mexico on the 18th and it has not arrived…"
                rows={4}
                aria-label="Your message"
                style={{
                  width: '100%',
                  marginTop: 'var(--pb-space-4)',
                  padding: 'var(--pb-space-4)',
                  borderRadius: 'var(--pb-radius-md)',
                  border: 0,
                  outline: 'none',
                  resize: 'vertical',
                  background: 'var(--pb-overlay-weak)',
                  color: 'var(--pb-text-on-dark)',
                  fontFamily: 'var(--pb-font-sans)',
                  fontSize: 'var(--pb-text-xs)',
                }}
              />
              <Card.Footer>
                <Button size="md" block iconEnd="send" disabled={message.trim().length === 0}>
                  Send to support
                </Button>
              </Card.Footer>
            </Card>

            <Card tone="light">
              <Text variant="caption" weight="semibold">Your conversations</Text>
              <Stack gap={0} className="pb-mt-3">
                {THREADS.map((thread) => (
                  <button key={thread.subject} type="button" className={checkout.line} style={{ width: '100%' }}>
                    <Stack grow gap={0} align="start">
                      <Text variant="caption" weight="semibold" truncate>{thread.subject}</Text>
                      <Text variant="eyebrow" tone="secondary">{thread.agent} · {thread.when}</Text>
                    </Stack>
                    <Pill tone={thread.status === 'Open' ? 'warning' : 'positive'}>{thread.status}</Pill>
                  </button>
                ))}
              </Stack>
            </Card>
          </Stack>
        </BentoSpan>
      </BentoGrid>
    </>
  )
}
